/*
 * Lazy-loaded components for the App shell.
 * Centralised here so both index.jsx and partials can import them
 * without circular dependencies.
 */
import loadable from '@loadable/component'

// Lazy load components only used on checkout (not needed on homepage)
export const CheckoutHeader = loadable(
    () => import('../../pages/checkout/partials/checkout-header'),
    {ssr: false}
)
export const CheckoutFooter = loadable(
    () => import('../../pages/checkout/partials/checkout-footer'),
    {ssr: false}
)

// Lazy load DrawerMenu - only needed when mobile menu opens (~80-100KB framer-motion savings)
export const DrawerMenu = loadable(() => import('../drawer-menu'), {ssr: false})

// Lazy load AccountModal - only used when user clicks account button (not on initial page load)
export const AccountModal = loadable(() => import('../account-modal'), {ssr: false})

// Lazy load AuthModal - only needed when user clicks login
export const AuthModal = loadable(
    () => import('../../hooks/use-auth-modal').then((m) => ({default: m.AuthModal})),
    {ssr: false}
)

// DIDOMI - Lazy load since it's conditionally rendered based on IS_DIDOMI_ENABLED_GARAGE
export const DidomiSDK = loadable(
    () => import('@didomi/react').then((m) => ({default: m.DidomiSDK})),
    {ssr: false}
)
